import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  DoughnutController,
  Title,
  Tooltip,
  Legend,
  Filler
} from "chart.js"

Chart.register(
  LineController,
  DoughnutController,
  ArcElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

const CHART_COLORS = [
  "#4f46e5", "#059669", "#dc2626", "#d97706", "#7c3aed",
  "#0d9488", "#e11d48", "#65a30d", "#ea580c", "#2563eb"
]

export default class extends Controller {
  static values = {
    inscriptionsOverTime: Array,
    byDiocese: Array,
    byParish: Array,
    byCommunity: Array,
    byChurchService: Array,
    byReservationOption: Array,
    byAccommodationAvailability: Array
  }

  connect() {
    this.renderLineChart()
    this.renderDonutCharts()
  }

  renderLineChart() {
    if (!this.inscriptionsOverTimeValue?.length) return

    const ctx = this.element.querySelector("[data-line-chart]")
    if (!ctx) return

    const { labels, data } = this.inscriptionsOverTimeValue.reduce(
      (acc, item) => {
        acc.labels.push(item.date)
        acc.data.push(item.count)
        return acc
      },
      { labels: [], data: [] }
    )

    new Chart(ctx, {
      type: "line",
      data: {
        labels,
        datasets: [{
          label: this.element.dataset.inscriptionsLabel || "Inscriptions",
          data,
          borderColor: "#4f46e5",
          backgroundColor: "rgba(79, 70, 229, 0.1)",
          fill: true,
          tension: 0.3
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: { stepSize: 1 }
          }
        }
      }
    })
  }

  renderDonutCharts() {
    const charts = [
      { key: "byDiocese", selector: "[data-donut-diocese]" },
      { key: "byParish", selector: "[data-donut-parish]" },
      { key: "byCommunity", selector: "[data-donut-community]" },
      { key: "byChurchService", selector: "[data-donut-church-service]" },
      { key: "byReservationOption", selector: "[data-donut-reservation-option]" },
      { key: "byAccommodationAvailability", selector: "[data-donut-accommodation-availability]" }
    ]

    charts.forEach(({ key, selector }) => {
      const value = this[`${key}Value`]
      if (!value?.length) return

      const ctx = this.element.querySelector(selector)
      if (!ctx) return

      const labels = value.map((v) => `${v.name} (${v.count})`)
      const data = value.map((v) => v.count)

      new Chart(ctx, {
        type: "doughnut",
        data: {
          labels,
          datasets: [{
            data,
            backgroundColor: labels.map((_, i) => CHART_COLORS[i % CHART_COLORS.length]),
            borderWidth: 2,
            borderColor: "#fff"
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom"
            }
          }
        }
      })
    })
  }
}
